import { MeshGradient } from '../types';
import { generateHarmonizedColors } from './colorUtils';
import { generateGradientName } from './nameGenerator';
import { getDescriptionForMood } from './descriptionGenerator';
import { gradientThemes } from './gradientThemes';

function determineColorMood(colors: string[]): 'calm' | 'vibrant' | 'dark' | 'light' | 'warm' | 'cool' {
  // Simple heuristic to determine mood based on color values
  const avgBrightness = colors.reduce((sum, color) => {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    return sum + (r + g + b) / (3 * 255);
  }, 0) / colors.length;

  const avgSaturation = colors.reduce((sum, color) => {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16) / 255;
    const g = parseInt(hex.substr(2, 2), 16) / 255;
    const b = parseInt(hex.substr(4, 2), 16) / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const saturation = max === 0 ? 0 : (max - min) / max;
    return sum + saturation;
  }, 0) / colors.length;

  if (avgBrightness < 0.3) return 'dark';
  if (avgBrightness > 0.7) return 'light';
  if (avgSaturation > 0.6) return 'vibrant';
  if (avgSaturation < 0.3) return 'calm';
  
  // Check if warm or cool based on red vs blue components
  const avgWarmth = colors.reduce((sum, color) => {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    return sum + (r > b ? 1 : -1);
  }, 0) / colors.length;

  return avgWarmth > 0 ? 'warm' : 'cool';
}

export function generateNewGradient(): MeshGradient {
  const colors = generateHarmonizedColors();
  const name = generateGradientName();
  const mood = determineColorMood(colors);
  const description = getDescriptionForMood(mood);
  const angle = Math.floor(Math.random() * 360);

  return {
    name,
    colors,
    angle,
    description
  };
}